import { useState } from "react";

export const TermsAndConditionPopUp = ({ cancelbtn, heading, isAccepted, setIsAccepted }) => {
    const [localAccepted, setLocalAccepted] = useState(isAccepted ? isAccepted : false);
    return (
        <>
            <div className="modal fade show"
                style={{
                    display: "flex", alignItems: 'center', backgroundColor: "#00000090",
                    zIndex: 99999, position: 'fixed', top: 0, left: 0, right: 0, bottom: 0
                }}>
                <div className="modal-dialog" role="document"
                    style={{
                        minWidth: '70%', height: '85vh', maxHeight: '85vh'
                    }}
                >
                    <div className="modal-content" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                        <div className="modal-header"
                            style={{
                                backgroundColor: '#16374e',
                            }}
                        >
                            <h5 className="card-title fw-bold text-white pt-1" style={{ paddingLeft: '10px' }} id="exampleModalLongTitle">{heading}</h5>

                            <button onClick={() => {
                                setLocalAccepted(false);
                                cancelbtn()
                            }}
                                type="button" className="close" style={{ marginLeft: "auto" }}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <div className="modal-body examination mx-0 pb-0" style={{ overflowY: 'auto', flex: 1 }}>
                            <div className="row">
                                <div className="row p-2 m-0 poppins-regular" >

                                    <span className="fw-bold">Force Majeure:</span>
                                    <p>If any events occur which are beyond the reasonable control of MILSO such as fire, flood, storms, epidemic or pandemic disease or any other events, we reserve the rights to cancel, suspend, or vary our services and for which we will not be held liable for breach of contract or in tort resulting from such events.  We will not be liable for any loss, damage, expense, charges, delays, or other liabilities that you may have due to an event outside of our reasonable control.</p>

                                    <hr className="mt-1" style={{ color: 'lightgray' }} />

                                    <span className="fw-bold">Copyright of Author/Publishers:</span>
                                    <p>Unless otherwise stated, MILSO /or its licensors own the intellectual property rights for all material on MILSOs. All intellectual property rights are reserved. The study material shared by MILSO to the registered participants are for their personal use only and no part of the study material/lectures may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording or otherwise without the prior permission of MILSO.  Any violation shall be dealt strictly according to the laws of the land.</p>

                                    <hr className="mt-1" style={{ color: 'lightgray' }} />

                                    <span className="fw-bold">Disclaimer:</span>
                                    <p>Every effort has been made to avoid errors or omissions in the lectures and the study material. Lectures and study material are prepared in accordance with the syllabus of the professional examinations with intention to assist the candidates to understand the subject thoroughly and to pass the examination successfully, although MILSO does not guarantee passing the examination.</p>
                                    <p>The examples used in the lectures to demystify the subjects are thoughts and practice of the lecturers who are industry experts and there is no reason to suppose that the same constitute an “office practice.”</p>
                                    <p>MILSO cannot in any way guarantee the suitability of recommendations made in the lecturers or in the study material for individual problems, and they shall not be under any legal liability of any kind in respect of or arising out of the form or contents of the lecture or study material any error therein, or the reliance of any person thereon. </p>
                                    <p>Any errors/commissions can be brought to our notice.</p>
                                    <p>All disputes are subject to Mumbai Jurisdictions.</p>

                                    <hr className="mt-1" style={{ color: 'lightgray' }} />

                                    <span className="fw-bold">REFUND AND RETURNS:</span>
                                    <p>We do not provide Refund or Return of any order placed.</p>

                                    {/* Checkbox */}
                                    <div className="terms-checkbox-wrapper">
                                        <div
                                            className={`terms-checkbox-container ${localAccepted ? 'checked' : ''}`}
                                            onClick={() => setLocalAccepted(!localAccepted)}
                                        >
                                            <input
                                                type="checkbox"
                                                id="termsCheckbox"
                                                className="cursor-pointer"
                                                checked={localAccepted}
                                                onChange={(e) => { setLocalAccepted(e.target.checked); setIsAccepted(e.target.checked) }}
                                                onClick={(e) => e.stopPropagation()}
                                            />
                                            <label htmlFor="termsCheckbox" className="terms-checkbox-label ps-2">
                                                {/* <i className={`fa-solid ${isAccepted ? 'fa-check-circle' : 'fa-circle'} me-2`}></i> */}
                                                I have read and agree to the Terms and Conditions
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                {/* Footer */}
                                <div className="modal-footer terms-modal-footer d-flex justify-content-center">
                                    <button
                                        type="button"
                                        className={`btn px-4 ${localAccepted ? 'btn-blue' : 'btn-secondary'}`}
                                        disabled={!localAccepted}
                                        onClick={() => {
                                            setIsAccepted(true);
                                            cancelbtn();
                                        }}
                                    >
                                        <i className="fa-solid fa-check me-2"></i>
                                        {localAccepted ? 'Accept and Close' : 'Accept Terms'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >

        </>
    )
}